const EnumDesignation = {
  MANUSCRIPT: "Manuscript",
  FIGURE: "Figure",
  SUPPLEMENTARY_FIGURE: "SupplementaryFigures",
  ADDITIONAL_FILE: "Additional",
  VIDEO_FILE: "Video",
  FULL_MANUSCRIPT: "ManuscriptPDF",
  LETTER_OF_REBUTAL: "RebuttalLetter",
  LETTER_OF_REBUTAL_PDF: "RebuttalLetterPDF",
  FIGURE_PDF: "FigurePDF",
  UNMARKED_MANUSCRIPT: "UnmarkedManuscriptPDF",
  MARKED_MANUSCRIPTS: "MarkedManuscript",
  MARKED_MANUSCRIPTS_PDF: "MarkedManuscriptPDF",
  OVERVIEW: "Overview",
  TABLES: "Tables",
  COVER_LETTER: "CoverLetter",
  POWERPOINTER_PRESENTATION: "Powerpoint Presentation",
  ABSTRACT: "Abstract",
  FULL_ARTICLE: "FullArticle",
};

export default EnumDesignation;
